import { useInView } from '@/hooks/useInView';

interface TestimonialCardProps {
  quote: string;
  name: string;
  title: string;
  delay?: number;
}

export default function TestimonialCard({ quote, name, title, delay = 0 }: TestimonialCardProps) {
  const { ref, isInView } = useInView(0.2);

  return (
    <div
      ref={ref as React.RefObject<HTMLDivElement>}
      className={`transition-all duration-700 ${
        isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
      style={{ transitionDelay: `${delay}s` }}
    >
      <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg h-full">
        {/* Quote mark */}
        <div className="text-5xl text-mk-pink-200 font-serif leading-none mb-4">"</div>

        <p className="text-gray-700 text-lg mb-6 italic">{quote}</p>

        <div className="flex items-center gap-4">
          {/* Avatar placeholder */}
          <div className="w-12 h-12 bg-gradient-to-br from-mk-pink-400 to-mk-pink-600 rounded-full flex items-center justify-center text-white font-bold">
            {name
              .split(' ')
              .map((n) => n[0])
              .join('')}
          </div>

          <div>
            <p className="font-semibold text-gray-900">{name}</p>
            <p className="text-sm text-gray-500">{title}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
